import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { concat, from, of, partition, throwError, TimeoutError, timer } from 'rxjs';
import { catchError, concatMap, ignoreElements, map, pluck, shareReplay, switchMap, timeout } from 'rxjs/operators';
import { environment } from '@environment/environment';
import { AbstractPlatform } from '@app/platform/platform';
var RegisterService = /** @class */ (function () {
    function RegisterService(http, platform) {
        this.http = http;
        this.platform = platform;
    }
    RegisterService.prototype.checkRegister = function (setupCode) {
        return this.registerInternal(setupCode, false)
            .pipe(map(function (responseText) { return JSON.parse(responseText); }));
    };
    RegisterService.prototype.register = function (setupCode) {
        return this.registerInternal(setupCode, true);
    };
    RegisterService.prototype.pollRegister = function () {
        var _this = this;
        return from(this.platform.getSerialNumber()).pipe(switchMap(function (serial) { return _this.http.post(environment.serverAddress + "/api/smartscreen/register-serial", { serial: serial }, { responseType: 'text' }); }), 
        // Insert success message
        concatMap(function (response) { return from([
            { type: 'PROGRESS', value: 'Erfolglreich' },
            { type: 'COMPLETE', value: response },
        ]); }), timeout(10000), 
        // When the request errors (403 until we are registered) we retry after 5s
        catchError(function (error) { return error instanceof HttpErrorResponse || error instanceof TimeoutError
            ? concat(of({ type: 'PROGRESS', value: registerErrorToString(error) }), timer(5000).pipe(ignoreElements()), _this.pollRegister())
            : throwError(error); }));
    };
    RegisterService.prototype.pollRegisterPartitioned = function () {
        var _a = partition(this.pollRegister().pipe(shareReplay({ refCount: true })), function (status) { return status.type === 'COMPLETE'; }).map(function (status$) { return status$.pipe(pluck('value')); }), secret$ = _a[0], progress$ = _a[1];
        return { secret$: secret$, progress$: progress$ };
    };
    RegisterService.prototype.registerInternal = function (setupCode, confirm) {
        var _this = this;
        var url = environment.serverAddress + '/api/smartscreen/register';
        return from(this.platform.getSerialNumber()).pipe(switchMap(function (serial) {
            return _this.http.post(url, {
                setupCode: setupCode,
                confirm: confirm,
                serial: serial,
            }, {
                responseType: 'text',
            });
        }));
    };
    return RegisterService;
}());
export { RegisterService };
function registerErrorToString(error) {
    if (error instanceof TimeoutError) {
        return 'Keine Antwort!';
    }
    if (error instanceof HttpErrorResponse) {
        if (error.status === 403) {
            if (error.error === 'unknown_serial') {
                return 'Unbekannte Seriennummer!';
            }
            if (error.error === 'already_registered') {
                return 'Seriennummer bereits zugeordnet!';
            }
        }
        if (error.status / 100 === 5) {
            return 'Serverfehler!';
        }
        if (error.status === 0) {
            return 'Keine Antwort!';
        }
    }
    return 'Unbekannter Fehler!';
}
